import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../../services/auth.service';
import { EsqueciSenhaComponent } from './esqueci-senha/esqueci-senha.component';
declare var bootstrap: any;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    EsqueciSenhaComponent
  ]
})

export class LoginComponent implements OnInit{

  constructor(private router: Router, private toastr: ToastrService, private authService: AuthService) {}
  processandoLogin = false;
  showPassword = false;
  email: string = '';
  senha: string = '';

  ngOnInit(): void {
    if(this.authService.verificarTokenValido()){
      this.router.navigate(['/area-logada']);
    }
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  async login() {
    this.processandoLogin = true;
    const validacao = this.validarFormulario();

    if (!validacao.valido) {
      this.toastr.error(validacao.mensagem, 'Erro de validação');
      this.processandoLogin = false;
      return;
    }

    try{
      const response = await this.authService.login({ email: this.email, senha: this.senha });
      if (response && response.token !== undefined) {
        this.router.navigate(['/area-logada']);
      }
    }
    finally{
      setTimeout(()=> {
        this.processandoLogin = false;
      }, 3000);
    }

  }

  validarFormulario(): { valido: boolean; mensagem?: string } {
    if (!this.email.trim()) {
      return {
        valido: false,
        mensagem: 'O campo e-mail é obrigatório'
      };
    }

    const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!regexEmail.test(this.email)) {
      return {
        valido: false,
        mensagem: 'Formato de e-mail inválido'
      };
    }

    if (!this.senha.trim()) {
      return {
        valido: false,
        mensagem: 'O campo senha é obrigatório'
      };
    }

    return { valido: true };
  }

  abrirModalEsqueciSenha() {
    const modalElement = document.getElementById('esqueciaSenha');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }
}
